import { useEffect, useState } from 'react';
import axios from './axios';
import { formatNewLinesInHtml } from './common/utilities';
import Message from './components/Message';

function Transcript() {
    const [messages, setMessages] = useState([]);
    const [error, setError] = useState("");
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        let path = window?.location?.search;
        if (path.includes("id")) {
            setLoading(true)
            axios.post("v1/convtranscript", { conversationId: path.split("id=")[1] })
                .then((res: any) => {
                    setLoading(false);
                    let messages = res.data?.reverse();
                    messages = (messages || []).map((m: any) => {
                        return {
                            ...m,
                            message: formatNewLinesInHtml(m.message)
                        }
                    })
                    setMessages(messages);
                }).catch((error: any) => {
                    console.log(error);
                    setLoading(false);
                    setError(error.message)
                })
        } else {
            setError("Invalid Url ");
        }
    }, []);

    return (
        isLoading ? <div>Loading...</div> : <div style={{ margin: 30 }}>
            {error ? <div>{error}</div> :
                <>
                    {(messages || []).map((message: any, index: number) => {
                        return <Message key={index} message={message} />
                    })}
                </>
            }
        </div>
    )
}

export default Transcript;